var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileBasic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_2748)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_504_2748",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 17.418,
    r: 16.875,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_504_2748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 20.2305C21.1348 20.2305 24.2812 17.084 24.2812 13.1992C24.2812 9.31445 21.1348 6.16797 17.25 6.16797C13.3652 6.16797 10.2188 9.31445 10.2188 13.1992C10.2188 17.084 13.3652 20.2305 17.25 20.2305ZM17.25 23.7461C12.5566 23.7461 3.1875 26.1016 3.1875 30.7773V32.5352C3.1875 33.502 3.97852 34.293 4.94531 34.293H29.5547C30.5215 34.293 31.3125 33.502 31.3125 32.5352V30.7773C31.3125 26.1016 21.9434 23.7461 17.25 23.7461Z",
    fill: "#6A7889"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_2748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.75,
    height: 33.75,
    fill: "white",
    transform: "translate(0.375 0.542969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBasic);
export default __webpack_public_path__ + "static/media/profileBasic.82436557e04cc5ec186e0c6d97083ce0.svg";
export { ForwardRef as ReactComponent };